// 配置API接口地址
let url = {}
switch (process.env.NODE_ENV) {
  case 'development':
    url = window.ipConfig.development
    break
  case 'test':
    url = window.ipConfig.test
    break
  case 'integrate':
    url = window.ipConfig.integrate
    break
  case 'production':
    url = window.ipConfig.production
    break
}
export default url
